import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

// Thank You page: Spanish only, path "/thank_you", "Volver al inicio" -> "/"
export default function ThankYou() {
  return (
    <div className="flex min-h-screen flex-col bg-[#f6f8fa] text-[#0f1f2c]" data-testid="thank-you-page">
      <header className="border-b border-[#dbe4ea] bg-[#0b3d5c] text-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
          <Link to="/" className="flex items-center gap-2" data-testid="thank-you-brand-link">
            <span
              className="text-lg font-semibold tracking-tight"
              style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
            >
              Valmerantio
            </span>
          </Link>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-5 py-16 md:px-8">
        <div className="max-w-xl rounded-2xl border border-[#dbe4ea] bg-white p-10 text-center shadow-sm">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#0f5c3f] text-white">
            <CheckCircle2 size={32} />
          </span>
          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.18em] text-[#0f5c3f]">
            Solicitud recibida
          </p>
          <h1
            className="mt-3 text-3xl leading-tight text-[#0b3d5c] md:text-4xl"
            style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
            data-testid="thank-you-title"
          >
            ¡Gracias! Hemos recibido tu información.
          </h1>
          <p className="mt-4 text-sm leading-relaxed text-[#4b5f70]">
            Uno de nuestros consultores certificados se pondrá en contacto contigo en un plazo máximo de 24 horas hábiles para agendar tu consulta gratuita.
          </p>
          <p className="mt-3 text-xs leading-relaxed text-[#6e8394]">
            Mientras tanto, te invitamos a revisar tu correo electrónico. Si no encuentras nuestra respuesta, revisa la carpeta de correo no deseado.
          </p>
          <Link
            to="/"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0b3d5c] px-6 py-3 text-sm font-semibold text-white hover:bg-[#08324b]"
            data-testid="thank-you-back-home"
          >
            Volver al inicio
          </Link>
        </div>
      </main>
      <footer className="border-t border-[#dbe4ea] bg-white">
        <div className="mx-auto max-w-7xl px-5 py-6 text-center text-xs text-[#6e8394] md:px-8">
          © 2026 Valmerantio Asesoría Financiera, S.A.P.I. de C.V.
        </div>
      </footer>
    </div>
  );
}
